<template>
  <div id="contenedor-listado-desktop">
    <v-data-table
      :headers="headers"
      :items="listadoContratos"
      :items-per-page="20"
    >
      <template v-slot:[`item.numero`]="{ item }">
        <router-link
          :to="{ name: 'contratoReporteActividades', params: { idContrato: item.id } }"
        >
          {{ item.numero }}
        </router-link>
      </template>
      <template v-slot:[`item.meta`]="{ item }">
        <cortar-texto
          :texto="item.meta">
        </cortar-texto>
      </template>
      <template v-slot:[`item.tipoDeObra`]="{ item }">
        <template
          v-if="item.obra">
          <v-chip
            small
            :color="item.obra.obra.tipo.color">
            {{ item.obra.obra.tipo.descripcion }}
          </v-chip>
        </template>
      </template>
      <template v-slot:[`item.fecha`]="{ item }">
        {{ new Date(`${item.fecha} 00:00:0`).toLocaleDateString() }}
      </template>
      <template v-slot:[`item.importe`]="{ item }">
        <template v-if="item.modificado.importe <= 0">
          {{ importeContrato(item) | currency }}
        </template>
        <template v-else>
          <span class="error--text font-weight-medium">
            {{ importeContrato(item) | currency }}
          </span>
        </template>
      </template>
      <template v-slot:[`item.fechaInicio`]="{ item }">
        <template v-if="!item.modificado.fechaInicio">
          <span class="base1--text font-weight-medium">
            {{ new Date(`${item.fechaInicio} 00:00:0`).toLocaleDateString() }}
          </span>
        </template>
        <template v-else>
          <span class="error--text font-weight-medium">
            {{
              new Date(
                `${item.modificado.fechaInicio} 00:00:0`
              ).toLocaleDateString()
            }}
          </span>
        </template>
      </template>
      <template v-slot:[`item.fechaTermino`]="{ item }">
        <template v-if="!item.modificado.fechaTermino">
          <span class="base1--text font-weight-medium">
            {{ new Date(`${item.fechaTermino} 00:00:0`).toLocaleDateString() }}
          </span>
        </template>
        <template v-else>
          <span class="error--text font-weight-medium">
            {{
              new Date(
                `${item.modificado.fechaTermino} 00:00:0`
              ).toLocaleDateString()
            }}
          </span>
        </template>
      </template>
      <template v-slot:[`item.cantidadEstimaciones`]="{ item }">
        <span class="font-weight-bold">
          <v-chip
            small
            :disabled="item.cantidadEstimaciones <= 0"
            :class="item.cantidadEstimaciones > 0 ? 'success' : 'warning'">
            {{ item.cantidadEstimaciones }}
          </v-chip>
        </span>
      </template>
      <template v-slot:[`item.avanceFisico`]="{ item }">
        <template
          v-if="item.porcentajeAvanceFisico">
          <v-chip
            small
            color="azul1">
            {{ item.porcentajeAvanceFisico }}%
          </v-chip>
        </template>
        <template
          v-else>
          <v-chip
            small
            disabled>
            0
          </v-chip>
        </template>
      </template>
      <!-- <template v-slot:[`item.supervisor`]="{ item }">
        <template
          v-if="item.responsables.length > 0">
          <v-tooltip
            v-if="!getAvatar(item)"
            top>
            <template
              v-slot:activator="{ on, attrs }">
              <v-avatar
                color="base6"
                size="36"
                v-bind="attrs"
                v-on="on">
                <span class="white--text">
                  {{ $inicialesNombre(getSupervisor(item)) }}
                </span>
              </v-avatar>
            </template>
            <span>
              {{ getSupervisor(item) }}
            </span>
          </v-tooltip>
          <perfil-usuario
            v-else
            soloImagen
            :usuarioId="getAvatar(item).funcionario.usuario.id">
          </perfil-usuario>
        </template>
      </template> -->
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :id="item.id"></opciones>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Opciones from './Opciones.vue';
import CortarTexto from '@/components/CortarTextos.vue';

export default {
  name: 'ListadoDesktop',
  props: {
    listadoContratos: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
    CortarTexto,
    // PerfilUsuario,
  },
  data() {
    return {
      headers: [
        {
          text: 'Número',
          align: 'start',
          sortable: false,
          value: 'numero',
        },
        { text: 'Tipo', value: 'tipoDeObra', sortable: false },
        { text: 'Objeto', value: 'meta', sortable: false },
        {
          text: 'Contratista',
          value: 'contratista.nombreRazonSocial',
          sortable: false,
        },
        {
          text: 'Fecha',
          value: 'fecha',
          sortable: false,
          align: 'center',
        },
        {
          text: 'F. Inicio',
          value: 'fechaInicio',
          sortable: false,
          align: 'center',
        },
        {
          text: 'F. Término',
          value: 'fechaTermino',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Importe',
          value: 'importe',
          align: 'end',
          sortable: false,
        },
        // {
        //   text: '',
        //   value: 'supervisor',
        //   align: 'center',
        //   sortable: false,
        // },
        {
          text: '# Est',
          value: 'cantidadEstimaciones',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Av. Fisico', value: 'avanceFisico', align: 'center', sortable: false,
        },
        { text: '', value: 'acciones', sortable: false },
      ],
    };
  },
  methods: {
    // getAvatar(contrato) {
    //   if (!contrato.responsables) return null;
    //   const supervisor = contrato.responsables
    //     .find((responsable) => responsable.principal === true);
    //   if (!supervisor.funcionario.usuario
    //   || !supervisor.funcionario.usuario.avatarPublicKey) return false;
    //   return supervisor;
    // },
    // getSupervisor(contrato) {
    //   if (!contrato.responsables) return null;
    //   const supervisor = contrato.responsables
    //     .find((responsable) => responsable.principal === true);
    //   const { nombre } = supervisor.funcionario;
    //   const buscarSiTieneProfesion = nombre.split('.');
    //   if (buscarSiTieneProfesion.length > 1) return buscarSiTieneProfesion[1];
    //   return nombre;
    // },
    importeContrato(contrato) {
      const {
        importeCostoDirecto,
        importeCostoIndirectos,
        importeUtilidad,
        importeCargosAdicionales,
        importe,
      } = contrato;
      const importeModificado = contrato.modificado.importe;
      let contratoImporteTotal = 0;
      if (contrato.esObraFinanciada) {
        contratoImporteTotal = this.$numberRound((
          importeCostoDirecto
          + importeCostoIndirectos
          + importeUtilidad
          + importeCargosAdicionales
          + importeModificado
        ));
      } else {
        contratoImporteTotal = importe + importeModificado;
      }
      return contratoImporteTotal;
    },
  },
};
</script>

<style lang="scss">
</style>
